import { checkoutWidgetWithAssignmentsSchema } from "@redotech/redo-conversion-core-common/checkouts/checkout-widget";
import * as z from "zod";

export const getCheckoutWidgets = {
  name: "getCheckoutWidgets" as const,
  description:
    "Lists all checkout optimization widgets for the authenticated team (upsells, content/image blocks, fulfillment cutoff, shipping option widgets, etc.). Each widget is returned with the IDs and names of the checkout experiences it is assigned to, either directly via the experience's widget list or as a rate table's shipping option widget. Takes no input; team is derived from the session.",
  input: z.object({}),
  output: z.array(checkoutWidgetWithAssignmentsSchema),
};
